import { Component, ViewChild } from '@angular/core';
import { Nav, Platform, Events } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { LoginPage } from '../pages/login/login';
import { BrowserBackService } from '../providers/browser-back-service/browser-back-service';

// 協会のメニュー
const SUPER_ADMIN_MENU = [
  { title: '管理画面トップ', action: "changePage", component: 'AdminContentsPage'},  
  { title: '企業一覧', action: "changePage", component: 'OfficesPage'},  
  { title: '企業別ユーザ一覧', action: "changePage", component: 'AdminUserListPage'},  
  { title: '受験状況確認', action: "changePage", component: 'AdminContentUserListPage'},  
  { title: 'JPUCシステム', action: "link", href: 'https://jpuc2.zetalabo.biz'},
  { title: 'ログアウト', action: "changePage", component: 'LogoutPage'},
];

// 受講者のメニュー(管理者)
const USER_ADMIN_MENU = [
  { title: '試験一覧',   action: "changePage", component: 'TopPage'},
  { title: 'ユーザ一覧', action: "changePage", component: 'UserListPage'},
  { title: '問い合わせ', action: "changePage", component: 'InquiryPage'},
  { title: 'JPUCシステム', action: "link", href: 'https://jpuc2.zetalabo.biz'},
  { title: 'ログアウト', action: "changePage", component: 'LogoutPage'},
];

// 受講者のメニュー(一般)
const USER_MENU = [
  { title: '試験一覧',   action: "changePage", component: 'TopPage'},
  { title: '問い合わせ', action: "changePage", component: 'InquiryPage'},
  { title: 'ログアウト', action: "changePage", component: 'LogoutPage'},
];


@Component({
  templateUrl: 'app.html'
})
export class MyApp {
  @ViewChild(Nav) nav: Nav;

  rootPage: any = LoginPage;

  pages: Array<{title: string, component?: any, action: string, href?: string}>;

  constructor(
    public platform: Platform,
    public statusBar: StatusBar,
    public splashScreen: SplashScreen,
    public events: Events,
    public browserBackService: BrowserBackService
  ) {
    this.initializeApp();

    // ログインユーザによってメニューを切り替える
    this.events.subscribe('changeMenu', (target) => {
      if (target === 'superAdmin') {
        this.pages  = SUPER_ADMIN_MENU;
      } else if (target === 'userAdmin') {
        this.pages  = USER_ADMIN_MENU;
      } else {
        this.pages  = USER_MENU;
      }
    });

    this.events.subscribe('EVENT_LOGIN_ERROR', (error) => {
      window.sessionStorage.removeItem('user');
      this.nav.setRoot(LoginPage);
    });

    // window.sessionStorage.removeItem('user');
    let user:any = JSON.parse(window.sessionStorage.getItem('user'));
    if (user) {
      // 事務局の場合
      if (user.isAdminOffice) {
        this.events.publish('changeMenu', 'superAdmin');    
      } else {
        // 一般企業の中でもroleでadminとuserにわかれる（メニューが違うのみ)
        if (user.role === 'admin') {
          this.events.publish('changeMenu', 'userAdmin');
        } else {
          this.events.publish('changeMenu', 'user');
        }  
      }
    }

    window.addEventListener('popstate', () => {
      console.log(':::popstate:::');
      browserBackService.trigger();
    }, false);

  }

  initializeApp() {
    this.platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      this.statusBar.styleDefault();
      this.splashScreen.hide();
    });
  }

  action(page:any) {

    if (page.action === 'link') {
      window.open(page.href, '_blank');
    } else {
      this.nav.setRoot(page.component);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts